import React, { useState } from "react";
import { Link } from "react-router-dom";
import { IoMenuSharp } from "react-icons/io5";
import "../Styles/nav.css";

function Navbar() {
  const [openLinks, setOpenLinks] = useState(false);

  const toggleNav = () => {
    setOpenLinks(!openLinks);
  };
  return (
      <div className="navbar">
        <div className="leftSide" id={openLinks ? "open" : "close"}>
          <Link to="/">
          <button>
          BeReal<span className="highlight">Timelapse.</span>
          </button>   
          </Link>
          <div className="hiddenLinks">
            <Link to="/"> Home </Link>
            <Link to="/contact"> Contact </Link>
            <Link to="/upload"> Upload </Link>
          </div>

        </div>
        <div className="rightSide">
          <Link to="/"> Home </Link>
          <Link to="/contact"> Contact </Link>
          <Link to="/upload"> Upload </Link>
          <button onClick={(toggleNav)}>
          <IoMenuSharp />
          </button>
        </div>
      </div>
    );
} 
    
export default Navbar;
